import withFormContext from './withFormContext';
import Input from './Input';
import Text from './Text';
import ButtonGroup from './ButtonGroup';
import ImageGroup from './ImageGroup';
import ImageBoxGroup from './ImageBoxGroup';
import FragranceGroup from './FragranceGroup';
import ColourGroup from './ColourGroup';
import FormulationGroup from './FormulationGroup';

const wrappedInput = withFormContext(Input);
const wrappedText = withFormContext(Text);
const wrappedButtonGroup = withFormContext(ButtonGroup);
const wrappedImageGroup = withFormContext(ImageGroup);
const wrappedImageBoxGroup = withFormContext(ImageBoxGroup);
const wrappedFragranceGroup = withFormContext(FragranceGroup);
const wrappedColourGroup = withFormContext(ColourGroup);
const wrappedFormulationGroup = withFormContext(FormulationGroup);

export { wrappedInput as Input };
export { wrappedText as Text };
export { wrappedButtonGroup as ButtonGroup };
export { wrappedImageGroup as ImageGroup };
export { wrappedImageBoxGroup as ImageBoxGroup };
export { wrappedFragranceGroup as FragranceGroup };
export { wrappedColourGroup as ColourGroup };
export { wrappedFormulationGroup as FormulationGroup };
